import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterNav from './partials/FooterNav';
import FooterSocial from './partials/FooterSocial';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

class Footer extends React.Component {

  render() {
    const {
      className,
      topOuterDivider,
      topDivider,
      ...props
    } = this.props;

    const classes = classNames(
      'site-footer',
      topOuterDivider && 'has-top-divider',
      className
    );

    return (
      <footer
        {...props}
        className={classes}
      >
        <div className="container">
          <div className={
            classNames(
              'site-footer-inner',
              topDivider && 'has-top-divider'
            )}>
            <div className="footer-top text-xxs">
              <div className="footer-blocks">
                <div className="footer-block">
                  <Logo className="mb-16" />
                  <div className="footer-copyright">&copy; 2021 ThreatKey™, Inc.</div>
                </div>
                <div className="footer-block">
                  <div className="footer-block-title">Company</div>
                  <ul className="list-reset mb-0">
                    <li>
                      <a href="/careers">Careers</a>
                    </li>
                    <li>
                      <a href="/press">Press</a>
                    </li>
                    <li>
                      <a href="/privacy-policy">Privacy Policy</a>
                    </li>
                  </ul>
                </div>
        {/*         <div className="footer-block">
                  <div className="footer-block-title">Uses cases</div>
                  <ul className="list-reset mb-0">
                    <li>
                      <a href="/use-study/threat-detection">Threat Detection</a>
                    </li>
                    <li>
                      <a href="/use-study/shadow-it">Shadow IT</a>
                    </li>
                    <li>
                      <a href="/use-study/incident-response">Incident Response</a>
                    </li>
                  </ul>
                </div> */}
                <div className="footer-block">
                  <div className="footer-block-title">Resources</div>
                  <ul className="list-reset mb-0">
                    <li>
                      <a href="https://docs.threatkey.com">Documentation</a>
                    </li>
                    <li>
                      <a href="https://docs.threatkey.com/integrations">Integrations</a>
                    </li>
                    <li>
                      <a href="https://docs.threatkey.com/security">Security</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-bottom space-between center-content-mobile text-xxs">
              <FooterNav />
              <FooterSocial />
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
